module.exports = __webpack_public_path__ + "static/media/Valk5.d9b5de26.png";